import { Injectable } from '@angular/core';
import { GraphqlService } from '@shared/services/http/graphql.service';
import gql from 'graphql-tag';

@Injectable({ providedIn: 'root' })
export class TelephoneService {

  private deleteTelephoneMutation = gql`
mutation($where: TelephoneWhereUniqueInput!) {
  deleteTelephone(where: $where) {
    id
  }
}`;

  private updateTelephoneMutation = gql`
mutation($data: TelephoneUpdateInput!, $where: TelephoneWhereUniqueInput!) {
  updateTelephone(data: $data, where: $where) {
    id
  }
}`;

  constructor(private graphqlService: GraphqlService) { }


  public deleteTelephone(where: any): Promise<any> {
    return this.graphqlService.mutate(this.deleteTelephoneMutation, { where });
  }

  public updateTelephone(where: any, data: any): Promise<any> {
    return this.graphqlService.mutate(this.updateTelephoneMutation, { data, where });
  }

}
